import React from 'react'
import { Tooltip } from '@material-ui/core'
import DescargaPdf from '../../../../../PdfDownload/container/DescargaPdf'
import TicketDeDescarga from '../../../../../PdfDownload/container/TicketDeDescarga'
import DetalleCarga from '../../../../../DetalleCarga/containers/DetalleCarga'

function OperacionesCamionesDescargados (props) {
  const { detalle, numero } = props
  const url = `${process.env.REACT_APP_PDF_URL}${numero}.pdf`

  const detalleCarga = [
    {
      titulo: 'Número CTG',
      value: numero
    },
    {
      titulo: 'Cereal',
      value: detalle.cereal
    },
    {
      titulo: 'Cereal variedad',
      value: detalle.cerealVariedad
    },
    {
      titulo: 'Exportador',
      value: detalle.exportador
    },
    {
      titulo: 'Fecha de bruto',
      value: detalle.fechaDeBruto
    },
    {
      titulo: 'Fecha de volcado',
      value: detalle.fechaDeVolcado
    },
    {
      titulo: 'Fecha de destare',
      value: detalle.fechaDeDestare
    },
    {
      titulo: 'Titular CPE',
      value: detalle.titular
    },
    {
      titulo: 'Titular de cupo',
      value: detalle.remitenteComercial
    },
    {
      titulo: 'Corredor',
      value: detalle.corredorVendedor
    },
    {
      titulo: 'Entregador',
      value: detalle.vendedor
    },
    {
      titulo: 'Chofer',
      value: detalle.chofer
    },
    {
      titulo: 'Patente de camión',
      value: detalle.camion
    },
    {
      titulo: 'Peso bruto',
      value: detalle.pesoBruto
    },
    {
      titulo: 'Peso tara',
      value: detalle.pesoTara
    },
    {
      titulo: 'Peso neto',
      value: detalle.pesoNeto
    },
    {
      titulo: 'Humedad',
      value: detalle.humedad
    },
    {
      titulo: 'Volcadora de camiones',
      value: detalle.volcadoraCamiones
    },
    {
      titulo: 'Calificación cereal',
      value: detalle.calificacionCereal
    }

  ]

  return (
    <div style={{ display: 'flex', flexDirection: 'row' }}>
      <DetalleCarga detalle={detalleCarga} />
      <Tooltip title={'Descargar PDF desde ARCA'}>
        <DescargaPdf url={url} filename={numero} />
      </Tooltip>
      <Tooltip title={'Certificado de descarga'}>
        <TicketDeDescarga numero={numero} />
      </Tooltip>
    </div>
  )
}

export default OperacionesCamionesDescargados
